export const SELECT_TARGET_OBJECT_TO_ADD = 'SELECT_TARGET_OBJECT_TO_ADD';
export const SELECT_FILTER_RECORD_BY = 'SELECT_FILTER_RECORD_BY';
export const SELECT_ASSOCIATION_ID = 'SELECT_ASSOCIATION_ID';
export const SELECT_SORT_BY = 'SELECT_SORT_BY';
export const SELECT_SORT_BY_ASSOCIATION_TIMESTAMP = 'SELECT_SORT_BY_ASSOCIATION_TIMESTAMP';
export const SELECT_MATCHING_DATA_SOURCE_PROPERTY = 'SELECT_MATCHING_DATA_SOURCE_PROPERTY';
export const SELECT_MATCHING_ENROLLED_PROPERTY = 'SELECT_MATCHING_ENROLLED_PROPERTY';
export const SELECT_MATCHING_PROPERTY_VALUE = 'SELECT_MATCHING_PROPERTY_VALUE';
export const RENAME_DATA_SOURCE = 'RENAME_DATA_SOURCE';